export default __webpack_public_path__ + "static/chiller_b.42d5ed293cb11db31f5bb75f8e4a63f3.svg";